import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {getEventId, getEventTitle} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useEventDateInformation} from '../../../../../../../../../commons/hooks/dates'
import {isMultiDay} from '../../../../../../../../../commons/selectors/event'
import {useWidgetState} from '../../../../../../hooks/state-provider'
import {getMultiDayText} from '../../../../../../selectors/events'
import s from '../event-list.scss'
import {EventListItemProps} from './interfaces'

export const EventListItem = ({selectedDate, event, onClick}: EventListItemProps) => {
  const {t} = useTranslation()
  const eventId = getEventId(event)
  const {startTime} = useEventDateInformation(eventId)
  const multiDay = useWidgetState(state => isMultiDay(state, event))
  const multiDayText = useWidgetState(state => getMultiDayText(state, eventId, selectedDate, t))

  return (
    <li
      className={s.event}
      onClick={onClick}
      onKeyDown={handleKeyPressEnterOrSpace(onClick)}
      tabIndex={0}
      data-hook={DH.calendarEventListItem(eventId)}
    >
      <div className={s.info}>
        <div className={s.title} data-hook={`event-title-${eventId}`}>
          {getEventTitle(event)}
        </div>
        <div className={s.time} data-hook={`event-time-${eventId}`}>
          {multiDay ? multiDayText : startTime}
        </div>
      </div>
    </li>
  )
}
